import { useQuery } from '@tanstack/react-query';
import { timeEntries, stundenzettel } from '@/utils/api';

export function useTimeEntries(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['time-entries', params],
    queryFn: () => timeEntries.getAll(params).then((r) => r.data),
  });
}

export function useTimeEntryStats(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['time-entries', 'stats', params],
    queryFn: () => timeEntries.getStats(params).then((r) => r.data),
  });
}

export function useStundenzettelOverview(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['stundenzettel', 'overview', params],
    queryFn: () => stundenzettel.getOverview(params).then((r) => r.data),
  });
}

export function useStundenzettelEmployees() {
  return useQuery({
    queryKey: ['stundenzettel', 'employees'],
    queryFn: () => stundenzettel.getEmployees().then((r) => r.data),
  });
}
